import { useTranslation } from 'react-i18next';
import { ColumnDef } from '@tanstack/react-table';
import { Button } from '@/components/ui/button';
import ArrowDownIconSolid from '@/components/icons/ArrowDownIconSolid';
import { NotificationDetailsReceiverResponseDto } from '@/features/notifications/types/notifications-dto';
import EDateText from '@/components/everridge/EDateText';
import EAvatar from '@/components/everridge/EAvatar';
import { cn } from '@/lib/utils';

const NotificationsDetailsColumns =
	(): ColumnDef<NotificationDetailsReceiverResponseDto>[] => {
		const { t } = useTranslation();

		const columnClasses = 'text-sm text-popover-800';

		return [
			{
				accessorKey: 'userName',
				header: ({ column }) => {
					return (
						<Button
							variant='link'
							className={
								'h-fit p-0 flex items-center gap-2.5 text-sm text-popover-1000 font-medium no-underline hover:no-underline'
							}
							onClick={() =>
								column.toggleSorting(
									column.getIsSorted() === 'asc',
								)
							}>
							{t('main.notifications.table.header.recipient')}
							<div
								className={`transition-transform duration-50 ease-in-out ${
									column.getIsSorted() === 'asc'
										? '-rotate-180'
										: 'rotate-0'
								}`}>
								{<ArrowDownIconSolid />}
							</div>
						</Button>
					);
				},
				cell: ({ row }) => (
					<div
						className={cn(
							'flex items-center gap-2.5 truncate',
							columnClasses,
						)}>
						<EAvatar
							url={row.original.avatar}
							className={'size-8'}
						/>
						<span className='truncate'>
							{row.getValue('userName')}
						</span>
					</div>
				),
			},
			{
				accessorKey: 'apartment',
				header: ({ column }) => {
					return (
						<Button
							variant='link'
							className={
								'h-fit p-0 flex items-center gap-2.5 text-sm text-popover-1000 font-medium no-underline hover:no-underline'
							}
							onClick={() =>
								column.toggleSorting(
									column.getIsSorted() === 'asc',
								)
							}>
							{t('main.notifications.table.header.apartment')}
							<div
								className={`transition-transform duration-50 ease-in-out ${
									column.getIsSorted() === 'asc'
										? '-rotate-180'
										: 'rotate-0'
								}`}>
								{<ArrowDownIconSolid />}
							</div>
						</Button>
					);
				},
				cell: ({ row }) => (
					<div className={`truncate ${columnClasses}`}>{'-'}</div>
				),
			},
			{
				accessorKey: 'readAt',
				header: ({ column }) => {
					return (
						<Button
							variant='link'
							className={
								'h-fit p-0 flex items-center gap-2.5 text-sm text-popover-1000 font-medium no-underline hover:no-underline'
							}
							onClick={() =>
								column.toggleSorting(
									column.getIsSorted() === 'asc',
								)
							}>
							{t('main.notifications.table.header.readAt')}
							<div
								className={`transition-transform duration-50 ease-in-out ${
									column.getIsSorted() === 'asc'
										? '-rotate-180'
										: 'rotate-0'
								}`}>
								{<ArrowDownIconSolid />}
							</div>
						</Button>
					);
				},
				cell: ({ row }) => (
					<div className={columnClasses}>
						{!!row.getValue('readAt') ? (
							<EDateText date={row.getValue('readAt')} />
						) : (
							t('main.notifications.table.header.unread')
						)}
					</div>
				),
			},
		];
	};

export default NotificationsDetailsColumns;
